import { render, staticRenderFns } from "./TravelSection.vue?vue&type=template&id=673dfe65&"
import script from "./TravelSection.vue?vue&type=script&lang=ts&"
export * from "./TravelSection.vue?vue&type=script&lang=ts&"
import style0 from "./TravelSection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports